/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Extendedsearch_Searchitems2Inputs */

const id_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari item...`)
};

const ms_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari item...`)
};

const da_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter items...`)
};

const de_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items durchsuchen...`)
};

const en_us2_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search items...`)
};

const es_es2_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar items...`)
};

const es_mx2_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar ítems...`)
};

const fil_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga item...`)
};

const fr_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des items…`)
};

const it_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca articoli...`)
};

const hu_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek keresése...`)
};

const nl_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek items...`)
};

const no_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter elementer...`)
};

const pl_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj elementów...`)
};

const pt_br2_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search items...`)
};

const pt_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar itens...`)
};

const ro_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută elemente...`)
};

const fi_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae kohteita...`)
};

const sv_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök objekt...`)
};

const vi_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm mục...`)
};

const tr_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeleri ara...`)
};

const cs_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat položky...`)
};

const bg_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на обекти...`)
};

const ru_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск объектов...`)
};

const uk_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук елементів...`)
};

const ar_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن عناصر...`)
};

const hi_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम खोजें...`)
};

const th_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหารายการ...`)
};

const ja_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムを検索...`)
};

const zh_cn2_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search items...`)
};

const zh_hant1_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search items...`)
};

const ko_components_extendedsearch_searchitems2 = /** @type {(inputs: Components_Extendedsearch_Searchitems2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search items...`)
};

/**
* | output |
* | --- |
* | "Search items..." |
*
* @param {Components_Extendedsearch_Searchitems2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_extendedsearch_searchitems2 = /** @type {((inputs?: Components_Extendedsearch_Searchitems2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Extendedsearch_Searchitems2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_extendedsearch_searchitems2(inputs)
	if (locale === "ms") return ms_components_extendedsearch_searchitems2(inputs)
	if (locale === "da") return da_components_extendedsearch_searchitems2(inputs)
	if (locale === "de") return de_components_extendedsearch_searchitems2(inputs)
	if (locale === "en-US") return en_us2_components_extendedsearch_searchitems2(inputs)
	if (locale === "es-ES") return es_es2_components_extendedsearch_searchitems2(inputs)
	if (locale === "es-MX") return es_mx2_components_extendedsearch_searchitems2(inputs)
	if (locale === "fil") return fil_components_extendedsearch_searchitems2(inputs)
	if (locale === "fr") return fr_components_extendedsearch_searchitems2(inputs)
	if (locale === "it") return it_components_extendedsearch_searchitems2(inputs)
	if (locale === "hu") return hu_components_extendedsearch_searchitems2(inputs)
	if (locale === "nl") return nl_components_extendedsearch_searchitems2(inputs)
	if (locale === "no") return no_components_extendedsearch_searchitems2(inputs)
	if (locale === "pl") return pl_components_extendedsearch_searchitems2(inputs)
	if (locale === "pt-BR") return pt_br2_components_extendedsearch_searchitems2(inputs)
	if (locale === "pt") return pt_components_extendedsearch_searchitems2(inputs)
	if (locale === "ro") return ro_components_extendedsearch_searchitems2(inputs)
	if (locale === "fi") return fi_components_extendedsearch_searchitems2(inputs)
	if (locale === "sv") return sv_components_extendedsearch_searchitems2(inputs)
	if (locale === "vi") return vi_components_extendedsearch_searchitems2(inputs)
	if (locale === "tr") return tr_components_extendedsearch_searchitems2(inputs)
	if (locale === "cs") return cs_components_extendedsearch_searchitems2(inputs)
	if (locale === "bg") return bg_components_extendedsearch_searchitems2(inputs)
	if (locale === "ru") return ru_components_extendedsearch_searchitems2(inputs)
	if (locale === "uk") return uk_components_extendedsearch_searchitems2(inputs)
	if (locale === "ar") return ar_components_extendedsearch_searchitems2(inputs)
	if (locale === "hi") return hi_components_extendedsearch_searchitems2(inputs)
	if (locale === "th") return th_components_extendedsearch_searchitems2(inputs)
	if (locale === "ja") return ja_components_extendedsearch_searchitems2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_extendedsearch_searchitems2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_extendedsearch_searchitems2(inputs)
	return ko_components_extendedsearch_searchitems2(inputs)
});
export { components_extendedsearch_searchitems2 as "components.extendedSearch.searchItems" }